var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-profile-picture"},[(_vm.imageUrl !== undefined)?_c('img',{staticClass:"app-profile-picture__image",attrs:{"src":_vm.imageUrl}}):_vm._e(),_c('el-avatar',[_vm._v(_vm._s(_vm.initials))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }